import { configureStore } from "@reduxjs/toolkit";
import { useSyncExternalStoreWithSelector } from "use-sync-external-store/with-selector.js";
//#region src/redux/create-independent-store.ts
/**
* normally redux encourages single-store apps, but as this repo contains
* multiple independent runtime applications we want to be able to create Redux
* stores that are embedded inside library packages and available for
* consumption without needing to re-create very large store objects in every
* single application
*
* some boilerplate is needed to create an independent store, which is
* abstracted by this utility
*
* in their raw form, these independent stores are essentially global and can
* be used anywhere without having to "provide" them in a React render tree,
* which is well-suited for global configurations such as user sessions,
* navigation etc.
*/
function createIndependentStore(slice) {
	var _slice$devTool;
	const store = configureStore({
		...slice,
		devTools: {
			...slice.devTool,
			name: ((_slice$devTool = slice.devTool) === null || _slice$devTool === void 0 ? void 0 : _slice$devTool.name) ?? slice.name
		}
	});
	function useSelector(selector, equalityFn) {
		return useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getState, selector, equalityFn);
	}
	return {
		actions: slice.actions,
		dispatch: store.dispatch.bind(store),
		getState: store.getState.bind(store),
		subscribe: store.subscribe.bind(store),
		useSelector
	};
}
//#endregion
export { createIndependentStore };

//# sourceMappingURL=create-independent-store.js.map